import { Link, createFileRoute } from '@tanstack/react-router'
import v1 from '@/assets/brand/logo-v1-summit-core.svg'
import v2 from '@/assets/brand/logo-v2-alpine-step.svg'
import v3 from '@/assets/brand/logo-v3-northline.svg'
import v4 from '@/assets/brand/logo-v4-summit-badge.svg'
import v5 from '@/assets/brand/logo-v5-minimal-altitude.svg'
import v6 from '@/assets/brand/logo-v6-reference-arrow.svg'
import styles from './logo-lab.module.css'

export const Route = createFileRoute('/logo-lab')({
  component: LogoLabRoute,
})

const LOGOS = [
  {
    id: 'v1',
    name: 'V1 Summit Core',
    note: 'Rounded-square badge, strongest single peak',
    src: v1,
  },
  {
    id: 'v2',
    name: 'V2 Alpine Step',
    note: 'Sharper geometry with internal arrow block',
    src: v2,
  },
  {
    id: 'v3',
    name: 'V3 Northline',
    note: 'Path-led ascent line ending in summit arrow',
    src: v3,
  },
  {
    id: 'v4',
    name: 'V4 Summit Badge',
    note: 'Circular badge with centered mountain arrow',
    src: v4,
  },
  {
    id: 'v5',
    name: 'V5 Minimal Altitude',
    note: 'Minimal stroke style for cleaner icon scaling',
    src: v5,
  },
  {
    id: 'v6',
    name: 'V6 Reference Arrow',
    note: 'Closest match to your provided concept, transparent background',
    src: v6,
  },
]

function LogoLabRoute() {
  return (
    <section className={styles.layout}>
      <header className={styles.header}>
        <p className={styles.kicker}>Brand Exploration</p>
        <h1 className={styles.title}>StatureBoost Mountain + Up-Arrow Concepts</h1>
        <p className={styles.subtitle}>
          Pick one and I will apply it across header, favicon, and all brand assets.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.linkButton}>
            Back to landing
          </Link>
          <Link to="/home" className={styles.linkButtonGhost}>
            Open app
          </Link>
        </div>
      </header>

      <div className={styles.grid}>
        {LOGOS.map((logo) => (
          <article key={logo.id} className={styles.card}>
            <div className={styles.previewDark}>
              <img src={logo.src} alt={logo.name} className={styles.logo} loading="lazy" />
            </div>
            <div className={styles.previewLight}>
              <img src={logo.src} alt="" className={styles.logoSmall} loading="lazy" />
              <p className={styles.wordmark}>StatureBoost</p>
            </div>
            <h2>{logo.name}</h2>
            <p>{logo.note}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
